import { format } from "date-fns";
import { es } from "date-fns/locale";

// Fase 14 — Los timestamps del backend son SIEMPRE UTC. Motor+FastAPI
// serializan con sufijo "+00:00" desde que activamos `tz_aware=True`,
// pero mantenemos este shim defensivo para tolerar cualquier ISO histórico
// (backfills, tests, docs escritos antes del fix) que llegue naive: si el
// string no incluye "Z" ni "±HH:MM" al final, lo forzamos a UTC. Sin esto,
// `new Date("2026-09-08T09:29:30.542")` se interpretaría como LOCAL time
// (regla ECMAScript para date-time strings sin offset), produciendo
// desfase de 1-2h en Madrid según DST.
function _asUtcAware(d) {
    if (typeof d !== "string") return d;
    return /[Zz]$|[+-]\d{2}:?\d{2}$/.test(d) ? d : d + "Z";
}

export function formatDate(d, fmt = "d MMM HH:mm") {
    if (!d) return "";
    try {
        const date = typeof d === "string" ? new Date(_asUtcAware(d)) : d;
        return format(date, fmt, { locale: es });
    } catch (_) { return ""; }
}

export function relativeMinutes(d) {
    if (!d) return "";
    const date = typeof d === "string" ? new Date(_asUtcAware(d)) : d;
    const diffMs = Date.now() - date.getTime();
    const min = Math.floor(diffMs / 60000);
    if (min < 1) return "ahora";
    if (min < 60) return `${min}m`;
    const h = Math.floor(min / 60);
    if (h < 24) return `${h}h`;
    const days = Math.floor(h / 24);
    if (days < 7) return `${days}d`;
    return formatDate(date, "d MMM");
}

export function getChannelMeta(ch) {
    switch (ch) {
        case "kimkim":  return { label: "KimKim",  color: "#0F4C81" };
        case "travefy": return { label: "Travefy", color: "#7C3AED" };
        case "whatsapp":return { label: "WhatsApp",color: "#16A34A" };
        case "email":   return { label: "Email",   color: "#0891B2" };
        default:        return { label: "Manual",  color: "#475569" };
    }
}

export const STATUS_LABEL = { open: "Abierta", snoozed: "Aplazada", closed: "Cerrada" };
export const STATUS_COLOR = {
    open:    { bg: "bg-emerald-50",   text: "text-emerald-700",  dot: "bg-emerald-500" },
    snoozed: { bg: "bg-amber-50",     text: "text-amber-700",    dot: "bg-amber-500" },
    closed:  { bg: "bg-slate-100",    text: "text-slate-600",    dot: "bg-slate-400" },
};
